import type { NodeId } from '@ipfabric/utils';
import { plainSet } from '@ipfabric/utils/fp/plainSet';
import type { GraphState } from 'components/Graph/GraphState';
import { selectNodeIds } from 'components/Graph/model/selectors/selectNodeIds';
import { array } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectNotSelectedVisibleNodeIds: (s: GraphState) => Set<NodeId> =
  createScopedSelector(() =>
    createSelector(
      selectNodeIds,
      (s) => s.graph.selectedNodeIds,
      (s) => s.graph.hiddenNodes,
      (nodeIds, selectedNodeIds, hiddenNodeIds) =>
        pipe(
          nodeIds,
          array.filter(
            (nodeId) =>
              !selectedNodeIds.has(nodeId) && !hiddenNodeIds.has(nodeId),
          ),
          plainSet.fromArray,
        ),
    ),
  );
